
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/cordial",
      function () {
        return require("private-next-pages/destinations/cordial.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/cordial"])
      });
    }
  